import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Stack } from "common/ui/Stack";
import { Heading } from "common/ui/Heading";
import { Paragraph } from "common/ui/Paragraph";
import { Button } from "common/ui/Button";

import styles from "./NoListingsView.module.scss";

export const NoListingsView = () => {
  const { t } = useTranslation(["admin"]);
  const router = useRouter();

  return (
    <div className={styles.NoListingsViewContainer}>
      <Heading variant="h1">{t("listings.noProperties")}</Heading>
      <Stack direction="column" gap={24} alignItems="center">
        <Paragraph variant="p1">
          {t("listings.startSelling")}
        </Paragraph>
        <Button
          variant="primary"
          onClick={() => router.push("/listings/property")}
          fullWidth
        >
          {t("listings.createListing")}
        </Button>
      </Stack>
    </div>
  );
}
